export const APP_TOKEN = 'APP_TOKEN';

export const availabilityOptions = [
  { value: '0', label: 'Διαθέσιμο' },
  { value: '1_3', label: '1-3 ημέρες' },
  { value: '3_10', label: '3-10 ημέρες' },
  { value: '10_30', label: '10-30 ημέρες' },
];
